import { combineReducers } from 'redux';

import analytics from '@/modules/analytics/redux/actions';
import bundle from '@/modules/bundles/redux/actions';

import appVersion from './appVersion/actions';
import autoAI from './auto-ai/actions';
import banners from './banners/actions';
import chat from './chat/actions';
import clipboard from './clipBoard/actions';
import collections from './collections/actions';
import confetti from './confetti/actions';
import dialogAlerts from './dialogAlerts/actions';
import expressions from './expressions/actions';
import featureFlags from './featureFlag/actions';
import forms from './forms/actions';
import insights from './insights/actions';
import accordion from './integrations/actions';
import macros from './macros/actions';
import modals from './modals/actions';
import nodes from './nodes/actions';
import permissions from './permissions/actions';
import presence from './presence/actions';
import recommendations from './recommendations/actions';
import session from './session/actions';
import sidebar from './sidebar/actions';
import uiConfig from './uiConfig/actions';
import usedNodesCache from './usedNodes/actions';
import user from './user/actions';
import values from './values/actions';
import broadcasts from '../modules/broadcast/redux/actions';
import campaigns from '../modules/campaigns/redux/actions';
import chatNew from '../modules/humanChat/redux/actions';
import onboarding from '../modules/onboarding/redux/actions';
import tryIt from '../modules/tryIt/redux/actions';

export const defaultState = {};

const reducer = () =>
  combineReducers({
    accordion,
    analytics,
    appVersion,
    autoAI,
    banners,
    broadcasts,
    bundle,
    campaigns,
    chat,
    chatNew,
    clipboard,
    collections,
    confetti,
    dialogAlerts,
    expressions,
    featureFlags,
    forms,
    insights,
    macros,
    modals,
    nodes,
    onboarding,
    permissions,
    presence,
    recommendations,
    session,
    tryIt,
    uiConfig,
    usedNodesCache,
    user,
    values,
    sidebar,
  });

export default reducer;
